class TotalBudget {
  constructor(budgetData = {}) {
    this.budget = budgetData.budget || 0;
    this.budgetLastMonth =
      budgetData.budgetLastMonth || budgetData.budget_last_month || 0;
  }
}

export default TotalBudget;
